<template>
  <div class="grid grid-cols-1 gap-8 w-full lg:grid-cols-2">
    <div
      v-for="(tool, index) in tools"
      :key="index"
      class="flex flex-col w-full border border-gray-200 rounded-lg shadow bg-[linear-gradient(180deg,_#FCFCFD_0%,_#F9FAFB_100%)]"
    >
      <div class="flex flex-col gap-1 p-6">
        <h1 class="text-2xl font-medium text-gray-900">
          {{ tool.name }}
        </h1>
        <p class="text-gray-700">
          {{ tool.description }}
        </p>
      </div>
      <img
        :src="tool.image"
        alt="tool-img"
        class="object-cover w-full h-40 sm:h-[244px]"
      >
    </div>
  </div>
</template>

<script setup lang="ts">
import { shallowRef } from "vue";
import Map from "@/../images/tabbed-bento-images/powerful-add-ons/map.png";
import QrCode from "@/../images/tabbed-bento-images/powerful-add-ons/qr-code.png";

const tools = shallowRef([
    {
        name: "Map",
        description:
            "Create custom maps with variable addresses for each recipient. This feature highlights specific locations, like sold homes or landscaped properties.",
        image: Map,
    },
    {
        name: "QR Code",
        description:
            "Stop wasting countless hours searching for the perfect image. Our  image library allows you to quickly find anything you need.",
        image: QrCode,
    },
]);
</script>
